/**
 * Modale "Come si fa?" con i 4 passi per leggere il contatore.
 * Replica i 4 STEPS del componente mobile `InstructionsModal`.
 *
 * Niente immagini contatore qui (le ho lasciate fuori dal bundle per ora),
 * solo testo numerato. In futuro si potrà aggiungere asset specifici.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

const STEPS = [
  {
    title: 'Premi il tasto del display',
    text:
      'Premi il tasto del display finché non trovi le voci A1+, A2+ e A3+ (rispettivamente le fasce F1, F2 e F3).',
  },
  {
    title: 'Al settimo click trovi A1+',
    text:
      'Al settimo click del tasto display vedrai la prima lettura: A1+, corrispondente alla fascia F1.',
  },
  {
    title: 'All’ottavo click trovi A2+',
    text:
      'Continuando, all’ottavo click trovi la lettura A2+, corrispondente alla fascia F2.',
  },
  {
    title: 'Al nono click trovi A3+',
    text:
      'Al nono click trovi A3+, corrispondente alla fascia F3. Annota le tre letture e inseriscile qui sotto. La data di rilevazione è il giorno in cui hai effettuato la lettura.',
  },
] as const

export function InstructionsDialog({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Come effettuare la lettura</DialogTitle>
          <DialogDescription>
            Segui questi passi per leggere il tuo contatore e inviare l’autolettura.
          </DialogDescription>
        </DialogHeader>
        <ol className="mt-4 flex flex-col gap-3">
          {STEPS.map((step, idx) => (
            <li
              key={idx}
              className="flex gap-3 rounded-lg border border-border bg-muted/30 p-4"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary text-sm font-bold text-secondary-foreground">
                {idx + 1}
              </span>
              <div className="flex flex-col gap-1">
                <p className="font-semibold text-foreground">{step.title}</p>
                <p className="text-sm text-muted-foreground">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </DialogContent>
    </Dialog>
  )
}
